import * as Api from '@ViewModels';
import { ContactViewModel } from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { EntityDonations } from '../donations/EntityDonations';
import { EntityMatters } from '../matters/EntityMatters';
import { EntityOpportunities } from '../opportunities/EntityOpportunities';
import { EntityPolicies } from '../policies/EntityPolicies';
import { EntityServiceJobs } from '../serviceJobs/EntityServiceJobs';
import { styleSheet } from './styles';

export const EntityDataBoards = observer(({ entityViewModel }: { entityViewModel: Api.EntityViewModel }) => {
	const userSession = useUserSession();
	const entity = entityViewModel.toJs();

	const { policiesEnabled, donationsEnabled, opportunitiesEnabled, matterBoard, serviceJobBoard } =
		userSession.account.features?.boards ?? {};
	const mattersEnabled = matterBoard?.enabled;
	const serviceJobsEnabled = serviceJobBoard?.enabled;

	return (
		<div className={css(styleSheet.container)}>
			{opportunitiesEnabled ? (
				<EntityOpportunities entity={entity} isContactMode={entityViewModel instanceof ContactViewModel} />
			) : null}

			{donationsEnabled ? <EntityDonations entity={entity} /> : null}

			{policiesEnabled ? <EntityPolicies entity={entity} /> : null}

			{mattersEnabled ? <EntityMatters entity={entity} /> : null}

			{serviceJobsEnabled ? <EntityServiceJobs entity={entity} /> : null}
		</div>
	);
});
